
import PopularizeRecord from '@/mobileComponents/popularize/PopularizeRecord'
import PopularizeWithdrawal from '@/mobileComponents/popularize/PopularizeWithdrawal'

export default {
  name: 'PopularizeInfo',
  data(){
    var checkMoney = (rule, value, callback) => {
      if (value < this.data.withdrawal_amount) {
        return callback(new Error('提现金额需要大于' + this.data.withdrawal_amount + '元'));
      } else if (value > this.data.residual_income) {
        return callback(new Error('提现金额不能超过您的剩余收益'));
      } else {
        callback();
      }
    };
    return {
      showLoading: true,
      recordCollapse:['1'],
      // 说明
      showMsg:false,
      //数据
      tuiguang_page: 1,
      tixian_page: 1,
      tixian_dialogVisible: false,
      extenstionUrl: '',
      GG: [
        '我正在用这家的域名检测监控报警系统，{url}，挺好用的。',
        '域名检测监控报警系统，QQ检测、微信检测、被墙/污染检测、抖音检测、360检测、备案检测、备案接入检测、绿标检测、链接状态检测等。站点地址：{url}',
        '来试试这家的域名检测监控报警系统，支持 QQ检测、微信检测、被墙/污染检测、抖音检测、360检测、备案检测、备案接入检测等。站点地址：{url}',
      ],
      data: {},
      shouyi_tableData: [],
      tixian_tableData: [],
      tixian_Form: {
        money: '',
        payee_type: 0,
        payee_account_number: '',
        payee_name: '',
        payee_bank_of_deposit: ''
      },
      tixian_Form_rules: {
        money: [
          {required: true, message: '请输入提现金额', trigger: 'blur'},
          {validator: checkMoney, trigger: 'blur'}
        ],
        payee_account_number: [
          {required: true, message: '请输入收款账户', trigger: 'blur'},
        ],
        payee_name: [
          {required: true, message: '请输入收款人姓名', trigger: 'blur'},
        ],
        payee_bank_of_deposit: [
          {required: true, message: '请输入开户行地址', trigger: 'blur'},
        ]
      },
      is_tixianing: false
    }
  },
  created() {
    if (this.$store.state.daili === 0) {
      this.$router.replace('popularize')
    } else {
      this.getData()
    }
  },
  components:{
    PopularizeRecord,
    PopularizeWithdrawal
  },
  methods:{
    // 复制url
    copyUrl() {
      let ggy = this.GG[parseInt(Math.random() * this.GG.length)].replace('{url}', this.extenstionUrl)
      this.$copyText(ggy)
      this.$toast.success('复制成功')
    },
    //方法
    async QrCode() {
      const {data} = await this.$http.get('/extension/withdrawalQRcode?text=' + this.extenstionUrl)
      let imgData = data
      this.downloadFile('推广二维码.png', imgData);
    },
    //下载
    downloadFile(fileName, content) {
      let aLink = document.createElement('a');
      let blob = this.base64ToBlob(content); //new Blob([content]);
      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      // aLink.dispatchEvent(evt);
      //aLink.click()
      aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },
    // 获取推广信息
    async getData() {
      try {
        const {data} = await this.$http.get('/extension/extensiondata')
        if (data.status === 'success') {
          this.showLoading = false
          this.extenstionUrl = data.data.shorturl
          this.data = data.data
          this.shouyi_tableData = data.data.log
          this.tixian_tableData = data.data.withdrawal_log
          //自动保存提现信息
          this.tixian_Form.payee_type = data.data.payee_type
          this.tixian_Form.payee_name = data.data.payee_name ? data.data.payee_name : ''
          this.tixian_Form.payee_account_number = data.data.payee_account_number ? data.data.payee_account_number : ''
          this.tixian_Form.payee_bank_of_deposit = data.data.payee_bank_of_deposit ? data.data.payee_bank_of_deposit : ''
        } else {
          this.showLoading = false
          this.$notify({type:'danger',message:data.msg})
        }
      } catch (e) {
        this.showLoading = false
        this.$notify({type:'danger',message:'网络异常，请稍后再试'})
      }
    },
    //关闭提现弹窗的处理
    handleClose_tixian_box() {
      this.tixian_dialogVisible = false
      this.$refs.tixianform.resetFields()
      this.tixian_Form.money = ''
    },
    // 提现
    tixian_main() {
      this.$refs.tixianform.validate(async bool => {
        if (bool) {
          this.is_tixianing = true
          try {
            const {data} = await this.$http.post('/extension/withdrawal', this.tixian_Form)
            if (data.status == 'success') {
              this.is_tixianing = false
              this.tixian_dialogVisible = false
              this.$notify({type:'success',message:data.msg})
            } else {
              this.is_tixianing = false
              this.$notify({type:'danger',message:data.msg})
            }
          } catch (e) {
            this.is_tixianing = false
            this.$notify({type:'danger',message:'网络异常，请稍后再试'})
          }
        }
      })
    },
    // 划转
    huazhuan() {
      this.$dialog.confirm({
        title: '提示',
        message: '是否确认将推广收益划转至余额?',
      }).then(async () => {
        try {
          const {data} = await this.$http.get('/extension/Transferbalance')
          if (data.status == 'success') {
            this.$notify({type:'success',message:data.msg})
            location.reload()
          } else {
            this.$notify({type:'danger',message:data.msg})
          }
        } catch (e) {
          this.$notify({type:'danger',message:'网络异常，请稍后再试'})
        }
      }).catch(()=>{
      })
    }
  }
}
